import { CategorySliderTypeResource } from '../@blocks/CategorySlider/CategorySlider';
import { transformToProductCategory } from '../@products/ProductCategory/ProductCategoryTransformers';
import { transformToImage } from '../Media/MediaTransformers';
import { transformToSeo } from '../Seo/SeoTransformers';
import { Space, SpaceItemResource } from './Space';

export const transformToSpace = (resource: SpaceItemResource): Space => {
    const image = resource.image
        ? transformToImage(resource.image)
        : undefined;

    const categories = resource.productCategories
        ? resource.productCategories.map(category => transformToProductCategory(category, CategorySliderTypeResource.lineImage))
        : undefined;

    const meilisearchProductListName = resource.productSelections
        ? resource.productSelections.name
        : '';

    const seo = resource.seo
        ? transformToSeo(resource.seo)
        : undefined;

    return {
        id: resource.documentId,
        name: resource.name,
        meilisearchProductListName,
        slug: resource.slug,
        image,
        title: resource.title || '',
        categories,
        order: resource.order || 0,
        seo,
    };
};
